import { useEffect, useRef } from 'react';

import { useSocketStore } from '../store/socket';
import { useSockets } from '../providers/socket';
import useContactStore from '../store/contact';
import useContactsStore from '../store/contacts';

const useDebounce = (callback: Function, delay: number) => {
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Cleanup the previous timeout on re-render
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const debouncedCallback = (...args: any) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // @ts-ignore
    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };

  return debouncedCallback;
};

type CleanupFn = () => void;
export function useHandleNewMessage(cleanup?: CleanupFn) {
  const { userSocket } = useSockets();
  const socketSessionReady = useSocketStore((state) => state.socketSessionReady);
  const newMessage = useContactStore((state) => state.newMessage);
  const updateContactsDb = useContactsStore((state) => state.updateContactsDb);

  useEffect(() => {
    if (!userSocket || !socketSessionReady) return;

    const handleNewMessage = (message: any) => {
      if (message.data) {
        console.log("setting up new data: ", message.data?.length);
        const dataArray = Array.isArray(message.data) ? message.data : [];
        newMessage(dataArray);
        updateContactsDb(dataArray);
      }
    };

    userSocket.on("new-message", handleNewMessage);

    return () => {
      console.log("cleaning up handler chats...");
      userSocket.off("new-message", handleNewMessage);

      if (cleanup) cleanup();
    };
  }, [userSocket, socketSessionReady]);
}

export default useDebounce;
